import { render, staticRenderFns } from "./discount_goods.vue?vue&type=template&id=07d68e01&"
import script from "./discount_goods.vue?vue&type=script&lang=js&"
export * from "./discount_goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d68e01')) {
      api.createRecord('07d68e01', component.options)
    } else {
      api.reload('07d68e01', component.options)
    }
    module.hot.accept("./discount_goods.vue?vue&type=template&id=07d68e01&", function () {
      api.rerender('07d68e01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_goods/discount_goods.vue"
export default component.exports